export const USER_ID = 'user-id';
export const USER_EMAIL = 'user-email';
export const VISITOR_ID = 'visitorId';
